import { render, staticRenderFns } from "./WhereDashboardModal.vue?vue&type=template&id=28a94326&"
import script from "./WhereDashboardModal.vue?vue&type=script&lang=ts&"
export * from "./WhereDashboardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports